<template>
  <div id="icon-menu-check">
    <b-navbar-toggle v-b-toggle.sidebar-backdrop right>
      <img
        src="/img/icons/svg/line_horizontal_filled_icon_200524_fff.svg"
        height="30"
        alt=""
      />
    </b-navbar-toggle>
    <div>
      <b-sidebar
        id="sidebar-backdrop"
        backdrop-variant="dark"
        backdrop
        shadow
        b-sidebar-right
        right
      >
        <sidebarHeader></sidebarHeader>
        <div class="py-2">
          <b-navbar-nav vertical>
            <b-dropdown-item
              :to="{ name: 'myInvoice' }"
              class="dropdown-link-hover my-2"
            >
              &nbsp;&nbsp;&nbsp;&nbsp; فاکتور های من
            </b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'profile' }"
              class="dropdown-link-hover my-2"
            >
              &nbsp;&nbsp;&nbsp;&nbsp; حساب کاربری  
            </b-dropdown-item>
            <b-dropdown-item
              class="dropdown-link-hover  my-2"
              href="#"
              v-on:click.prevent="logOut()"
            >
              &nbsp;&nbsp;&nbsp;&nbsp;خروج
            </b-dropdown-item>
          </b-navbar-nav>
        </div>
        <div class="footer">
          <hr class="footer-line" />
          Version : {{ version }}
        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import SidebarHeader from "./dropdownMenu/SidebarHeader.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    SidebarHeader,
  },
  mounted() {
  },
  computed: {
    ...mapGetters({
    }),
  },
  data() {
    return {
      version: null,
    };
  },
  beforeMount() {
    this.version = process.env.VUE_APP_VERSION;
  },
  methods: {
    logOut: function () {
      this.$emit("send-logOut");
    },
  },
};
</script>

<style></style>
